const parseVersionString = (versionString: string) =>
  versionString
    .replace('v', '')
    .split('.')
    .map((version) => Number(version));

export const isVersionMismatch = (
  frontendVersion = '',
  backendVersion = '',
) => {
  const stringsAreValid =
    frontendVersion.startsWith('v') && backendVersion.startsWith('v');
  if (!stringsAreValid) return false;

  const [majorFrontendVersion, minorFrontendVersion = 0] =
    parseVersionString(frontendVersion);
  const [majorBackendVersion, minorBackendVersion = 0] =
    parseVersionString(backendVersion);

  const majorVersionMismatch = majorFrontendVersion < majorBackendVersion;
  const minorVersionMismatch =
    majorBackendVersion === majorFrontendVersion &&
    minorFrontendVersion < minorBackendVersion;

  return majorVersionMismatch || minorVersionMismatch;
};
